module.exports = __webpack_public_path__ + "img/sc.15738e36.jpg";